<template>
    <div class="row">
        <div class="col-md-12 card-wrapper">
            <div class="card">
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('GENERAL_COMPANY_SETTINGS')}}</div>
                <div class="card-body bg-light color-gray">
                    <div class="row">
                        <div class="col-md-6">
                            <div>
                                <label class="new-label">{{$ml.get('CO_NAME')}}</label>
                                <input type="text" v-model="companyName" class="new-input" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div>
                                <label class="new-label">{{$ml.get('COMPANY_TIMEZONE')}} 
                                    <v-popover class="d-inline-block" style="cursor:pointer;">
                                    <i class="fa fa-info-circle tooltip-target b3" ></i>
                                        <template #popover>
                                            <p><i class="fa fa-info-circle fa-3x"></i></p>
                                            <p>
                                            {{$ml.get('COMPANY_TIMEZONE_INFO')}}
                                            </p>

                                            <a v-close-popover class="btn bg-new-primary text-white">{{$ml.get('COMPLETE')}}</a>
                                        </template>
                                    </v-popover>
                                </label>
                                <select v-model="timeZone" class="new-input">
                                    <option v-for="(timezone,index) in timezones" :key="index" :value="timezone">{{timezone}}</option>
                                </select>
                            </div>
                            <div>
                                <label class="new-label">{{$ml.get('DEFAULT_CURRENCY')}}</label>
                                <select v-model.number="currencyId" class="new-input">
                                    <option v-for="(cur,index) in currencyData()" v-bind:key="index" :value="cur.id">{{cur.label}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer crm-modal-footer text-right">
                    <button class="btn " @click="resetForm()">{{$ml.get('CANCEL')}}</button>
                    <button class="btn bg-new-primary w-150p " @click="updateCompanySettingsF()">{{$ml.get('SAVE')}}</button>
                </div>
            </div>
        </div>
        <div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="confirmModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title f-w-normal font-family-bold" id="exampleModalLongTitle">{{$ml.get('CURRNECY_CONFIRM_MODAL_TITLE')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="dealLosePopup border-radius-20 light-blue-border dealBtnStyle">
                            <div v-if="$ml.current=='tr'">
                                <p>Kullandığınız varsayılan para birimini değiştirmek geri alınamayacak etkiler yaratabilir.</p>
                                <p><span class="h3">Önemli Bilgilendirme!</span></p>
                                <p>Varsayılan para birimi;</p>
                                <ul>
                                    <li>Fırsatlar modülündeki göstergelerde</li>
                                    <li>Detay ekranlarındaki fırsat sekmelerinde</li>
                                    <li>Raporlarınızda gösterilecek tutarların hesaplanmasında kullanılır.</li>
                                </ul>
                                <p><strong>Önemli Not:</strong></p>
                                <p>Fırsatınızın varsayılan para birimine göre değeri fırsatın yaşam döngüsünde aşağıdaki 3 durumda hesaplanır:
                                </p>
                                <ul>
                                    <li>Fırsatınız oluşturulduğunda</li>
                                    <li>Fırsatınızın değeri değiştiğinde</li>
                                    <li>Fırsatınız kapandığında (sonuçlandığında)</li>
                                </ul>
                                <p>Örnek olarak varsayılan para biriminiz Türk Lirası. $100 değerinde bir fırsatı 04/02/2021 tarihinde oluşturdunuz.
                                    04/02/2021 tarihindeki $ (USD) kuru 7,12 olarak kabul edelim. Bu fırsatın varsayılan para birimindeki karşılığı
                                    712 TL'dir.</p>
                                <p>Eğer varsayılan para birimini ileride &euro; (Euro)' ya çevirirseniz, değişiklik tarihinden
                                    <strong>sonra</strong> farklı para birimlerinde açılan fırsatların varsayılan değeri Euro'ya göre sorunsuz
                                    çevrilmeye devam edecektir.</p>
                                <p>Fakat varsayılan para birimi <strong>değişim tarihinden önce oluşturulmuş (açık/kapalı)</strong> fırsatların
                                    değerleri Euro'ya çevrilmeyecektir, değer Euro olarak belirtilecektir.</p>
                                <p><strong>Yukarıdaki bahsi geçen örnekte varsayılan para birimi değişiminden sonra fırsat değeri $100'ın Euro
                                        karşılığı olarak değil, &euro;712 olarak gelecektir.</strong><br /><strong>Önceki para birimi olan Türk
                                        Lirasında 100 TL olarak açılmış bir fırsat da, yeni para birimi Euro olduğunda &euro;100 olarak
                                        gelecektir.</strong></p>
                                <p><strong>Uyarı!</strong></p>
                                <ul>
                                    <li>Seçilen varsayılan para birimi <strong>hesabınızdaki tüm kullanıcılar</strong> tarafından kullanılacaktır.
                                    </li>
                                    <li>Bu kapsamda seçeceğiniz varsayılan para değerinden emin olmanız gerekmektedir.</li>
                                    <li>Varsayılan para birimini değiştirdiğinizde yukarıdaki örnekte yer alan durumlar söz konusu olabilir.</li>
                                </ul>
                            </div>
                            <div v-else>
                                <p>Changing the <strong>default currency</strong> may have irreversible effects for your account.</p>
                                <p><span class="h3">Important Information</span></p>
                                <p>The default currency is used below;</p>
                                <ul>
                                    <li>The dashboard in the deals module</li>
                                    <li>In deal tabs on detail screens</li>
                                    <li>In the amounts to be shown in the reports.</li>
                                </ul>
                                <p>The default currency is your base currency. It operates at the company level. Users can create deals in various
                                    currencies in Minimum CRM. All deals that are created in other currencies are converted to default currency as an
                                    aggregate.&nbsp;</p>
                                <p><strong>Important note:</strong></p>
                                <p>It is important to remember that the deal value in the base currency will be calculated for a deal thrice along the
                                    lifecycle of the deal</p>
                                <ul>
                                    <li>When the deal is created</li>
                                    <li>When the deal&rsquo;s value is changed</li>
                                    <li>When the deal is closed (finalized)</li>
                                </ul>
                                <p>For example, consider your default currency is ₺ (Turkish Lira).&nbsp;</p>
                                <p>A deal of $100 in value was created on 04/02/2021. Let's take the $ (USD) exchange rate on 04/02/2021 as ₺ 7,12. So
                                    this deal is calculated as ₺712 in the default currency.&nbsp;</p>
                                <p>If after some time you wish to change the default currency to &euro; (Euro), the values of the deals you create
                                    <strong>after</strong> the change of the default currency will be converted to Euro with no problems.&nbsp;&nbsp;
                                </p>
                                <p>However, the values of all deals (open/closed) that have been <strong>created <span style="text-decoration: underline;">before</span> the change of the default currency</strong> will
                                    <strong>not be</strong> converted to Euro straight away.&nbsp;</p>
                                <p><strong>Consider our previous example where there was a deal with a value of $100. After you change the default
                                        currency from Turkish Lira to Euro, the value in the default currency will not be the equivalent of $100 in
                                        Euros but simply be taken as &euro;712. Since it is the value according to the previous default
                                        currency.</strong></p>
                                <p><strong>Another example is like this. Consider you had opened a deal before the change of the default currency which
                                        was Turkish Lira. The value was&nbsp; ₺100. Once you change the default currency to Euro, the value will not be
                                        the equivalent of ₺100 in Euros but simply be taken as &euro;100.</strong></p>
                                <p><strong>Warning!</strong></p>
                                <ul>
                                    <li>The default currency chosen will be used by all users in your account.</li>
                                    <li>In this context, you need to be sure of the default currency you choose.</li>
                                    <li>The change of the default currency can cause such incidents described above.</li>
                                </ul>
                            </div>
                            <p>
                                <label for="confirm">
                                    <input type="checkbox" v-model="confirmed" id="confirm" class="mr-2"> {{$ml.get('CHANGE_CURRENCY_CONFIRM_TEXT')}}
                                </label>
                                <p class="alert-input" v-if="confirmError.state">{{confirmError.message}}</p>
                            </p>
                        </div>
                    </div>
                    <div class="modal-footer dealBtnStyle">
                        <button type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        <button type="button" class="btn-new save" @click="proceed()">{{$ml.get('PROCEED')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
<script>
import { mapState,mapGetters,mapActions } from 'vuex'
export default {
    name:'generalCompanySettings',
    data() {
        return {
            companyName:'',
            timeZone:'Etc/UTC',
            currencyId:'',
            confirmed:false,
            confirmError:{state:false,message:''}
        }
    },
    computed: {
        ...mapState(['timezones']),
        ...mapGetters(['company_settings'])
    },
    methods: {
        ...mapActions(['getCompanySettings','updateCompanySettings']),
        setFormData(){
            
            this.companyName = this.company_settings.companyName
            this.timeZone = this.company_settings.timeZone
            this.currencyId = this.company_settings.currency

        },
        resetForm(){
            this.setFormData()
        },
        proceed(){
            if(!this.confirmValidation()){
                return false
            }
            this.updateCompanySettingsF()
        },
        updateCompanySettingsF(){

            if(this.currencyId!==this.company_settings.currency&&!this.confirmed){
                $('#confirmModal').modal('show')
                return false
            }

            let form = {}
            if(this.companyName!=''){
                form.companyName= this.companyName
            }
            if(this.timeZone!=''){
                form.timeZone= this.timeZone
            }
            if(this.currencyId!=''){
                form.currencyId= parseInt(this.currencyId)
            }
            
            this.updateCompanySettings(form).then((res)=>{return res}).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                    this.getCompanySettings().then((res)=>{ return res}).then((res)=>{
                        this.setFormData()
                    }) 
                    localStorage.defaultCurrency = this.currencyId
                    $('#confirmModal').modal('hide')
                    this.confirmed=false
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        confirmValidation(){
            this.confirmError.message = ""
            this.confirmError.state = false
            if(!this.confirmed){
                this.confirmError.message = this.$ml.get('CONFIRM_TO_PROCEED')
                this.confirmError.state = true
                return false
            }else{
                return true
            }
        }
        
    },
    created() {
        this.getCompanySettings().then((res)=>{ return res}).then((res)=>{
            this.setFormData()
        })  

        
    },
}
</script>
<style scopped>
.popover-inner{
    color:#7F8FA4!important;
}
</style>
